if (!customElements.get('media-gallery')) {
    customElements.define(
        'media-gallery',
        class MediaGallery extends HTMLElement {
            constructor() {
                super();

                const mainEl = this.querySelector('.slideMain');
                const thumbEl = this.querySelector('.slideChild');
                if (!mainEl || !thumbEl || !window.Swiper) return;
                const slideDesktop = parseInt(mainEl.dataset.slides) || 1;

                this.thumbSwiper = new Swiper(thumbEl, {
                    // Swiper strips loading="lazy" off the neighbouring slides so their
                    // images are already in cache by the time the user reaches them.
                    lazyPreloadPrevNext: 2,
                    spaceBetween: 5,
                    slidesPerView: 8,
                    freeMode: true,
                    watchSlidesProgress: true,
                    observer: true,
                    observeParents: true,
                });
                this.mainSwiper = new Swiper(mainEl, {
                    // One slide ahead at load so it does not compete with the LCP image.
                    // Widened on first interaction, see below.
                    lazyPreloadPrevNext: 1,
                    spaceBetween: 5,
                    slidesPerView: slideDesktop,
                    "autoHeight": true,
                    navigation: {
                        nextEl: this.querySelector('.swiper-button-next-product'),
                        prevEl: this.querySelector('.swiper-button-prev-product'),
                    },
                    thumbs: {
                        swiper: this.thumbSwiper,
                    },
                    observer: true,
                    observeParents: true,
                });
                // Once the visitor is actually browsing the gallery, keep a wider
                // buffer so quick taps through the slides never hit a blank frame.
                this.mainSwiper.once("slideChange", () => {
                    this.mainSwiper.params.lazyPreloadPrevNext = 3;
                });

                const variantId = new URLSearchParams(window.location.search).get('variant');

                if (variantId && window.productVariants) {
                    const variant = window.productVariants.find(
                        v => String(v.id) === variantId
                    );

                    if (variant && variant.featured_media) {
                        setTimeout(() => {
                            this.setActiveMedia(variant.featured_media.id);
                        }, 100);
                    }
                }
                document.addEventListener('variant:change', (event) => {
                    const variant = event.detail.variant;

                    if (variant && variant.featured_media) {
                        this.setActiveMedia(variant.featured_media.id);
                    }
                });
            }

            setActiveMedia(mediaId) {
                if (!this.mainSwiper) return;

                const slides = Array.from(
                    this.mainSwiper.slides
                );

                const index = slides.findIndex(
                    (slide) => String(slide.dataset.mediaId) === String(mediaId)
                );

                if (index === -1) return;

                this.mainSwiper.slideTo(index, 300);
            }
        }
    );
}
